// extracted by mini-css-extract-plugin
export default {"container":"Nh_Odo","logoContainer":"t6FoxY","logo":"cfFedn"};